export const NODE_URL = `${process.env.REACT_APP_NODE_URL}`
export const IDM_URL = `${process.env.REACT_APP_IDENTITY_URL}`
export const AUTH_DASHBOARD_DOMAIN = `${process.env.REACT_APP_AUTH_DASHBOARD_DOMAIN}`
export const AUTH_DASHBOARD_URL = `${process.env.REACT_APP_AUTH_DASHBOARD_URL}`
export const HELP_CENTER_URL = 'https://brands-creatorco.zendesk.com/hc/en-us'

export const BOOK_DEMO_URL = 'https://app.apollo.io/#/meet/7dh-9ec-ert/30-min'

export const CHARGEBEE_SITE =
  process.env.NODE_ENV === 'production' ? 'shopandshout' : 'shopandshout-test'

export const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID

export const DEFAULT_LOCALE = 'en-US'
export const DEFAULT_CURRENCY = 'USD'
